export const formatOrderSlugs = (orderSlugs: string[]) => orderSlugs.map((slug) => `#${slug}`).join(', ');
